<!-- Horizontal Table Layout -->
@if (!verticalLayout) {
  <table role="presentation" #table>
    <caption class="is-visually-hidden">
      {{ title }}
    </caption>
    <tbody>
      @if (title) {
        <tr aria-hidden="true" class="is-heading">
          <td [attr.colspan]="(entries?.length + 1)">
            <sd-title [titleLevel]="titleLevel" customClass="brand--h5">
              {{ title }}
            </sd-title>
          </td>
        </tr>
      }
      @if (doubleEntries && customTemplate) {
        <ng-container *ngTemplateOutlet="customTemplate" />
      }
      @for (column of columns | slice: 0 : maxLine; track column.id) {
        <ng-container #tableRow>
          @if (!column.hidden) {
            <tr>
              @if (isMobile) {
                <tr class="is-sub-caracteristic is-bold is-caption">
                  <sd-table-cell
                    [cellContent]="column.label"
                    (linkClicked)="onLinkClicked($event)"
                    (cellClicked)="onClick($event)"
                    [isInline]="true"
                  />
                </tr>
              } @else {
                @if (column.doubleEntry) {
                  <th class="c__empty-cell"></th>
                } @else {
                  <th scope="row" class="{{ getClass(column.width) }}">
                    <sd-table-cell
                      [cellContent]="column.label"
                      (linkClicked)="onLinkClicked($event)"
                      (cellClicked)="onClick($event)"
                    />
                  </th>
                }
              }
              @for (element of entries; track $index) {
                <td class="{{ getClass(column.width) }}">
                  <sd-table-cell
                    [cellContent]="element[column.id]"
                    (linkClicked)="onLinkClicked($event)"
                    (cellClicked)="onClick($event)"
                    [type]="column.type"
                  />
                </td>
              }
              @if (maxColumn) {
                @if (entries.length < (maxColumn - 1)) {
                  <td>
                    <sd-table-cell (linkClicked)="onLinkClicked($event)" />
                  </td>
                } @else if (entries.length === (maxColumn - 1)) {
                  <td>
                    <sd-table-cell (linkClicked)="onLinkClicked($event)" />
                  </td>
                }
              }
            </tr>
          }
        </ng-container>
      }
    </tbody>
  </table>
}

<!-- Vertical Table Layout -->
@if (verticalLayout) {
  <table role="presentation">
    <caption class="is-visually-hidden">
      {{ title }}
    </caption>
    <tbody>
      @if (title) {
        <tr aria-hidden="true" class="is-heading">
          <td [attr.colspan]="columns.length">
            <sd-title [titleLevel]="titleLevel" customClass="brand--h5">
              {{ title }}
            </sd-title>
          </td>
        </tr>
      }
      <tr aria-hidden="true" class="c__heading">
        @for (column of columns | slice: 0 : maxColumn; track column.id) {
          @if (!column.hidden) {
            @if (column.doubleEntry) {
              <th class="c__empty-cell"></th>
            } @else {
              <th scope="row" class="{{ getClass(column.width) }}">
                <sd-table-cell
                  [cellContent]="column.label"
                  (linkClicked)="onLinkClicked($event)"
                  (cellClicked)="onClick($event)"
                />
              </th>
            }
          }
        }
      </tr>
      @for (element of entries | slice: 0 : (maxLine - 1); track $index) {
        <tr #tableRow>
          @for (column of columns | slice: 0 : maxColumn; track column.id) {
            @if (!column.hidden) {
              <td class="{{ getClass(column.width) }}">
                <sd-table-cell
                  [cellContent]="element[column.id]"
                  (linkClicked)="onLinkClicked($event)"
                  (cellClicked)="onClick($event)"
                  [type]="column.type"
                />
              </td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
}

@if (maxLine && (!verticalLayout ? maxLine < columns.length : maxLine < entries.length)) {
  <button #showMoreButton sd-button [brand]="brand" class="c__see-more" (click)="showMore()">
    {{('actions.showMore' | translate) || '...'}}
  </button>
}
